import { render, staticRenderFns } from "./WelcomeBannerComponent.vue?vue&type=template&id=9288a802"
import script from "./WelcomeBannerComponent.vue?vue&type=script&lang=js"
export * from "./WelcomeBannerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports